<template>
    <svg width="12" height="12" viewBox="0 0 12 12" xmlns="http://www.w3.org/2000/svg">
        <path
            d="M12 3.993c0 .55-.45 1.001-1 1.001-.09 0-.18-.02-.26-.04L9.55 9.308c-.03.11-.13.18-.24.18H2.69c-.11 0-.21-.08-.24-.18L1.26 4.954c-.08.02-.17.04-.26.04-.55 0-1-.45-1-1.001 0-.55.45-1.001 1-1.001s1 .45 1 1.001c0 .16-.04.31-.11.45l1.9.951c.12.06.26.02.33-.1l1.39-2.432A.994.994 0 0 1 5 2C5 1.451 5.45 1 6 1s1 .45 1 1.001c0 .37-.21.69-.51.86l1.39 2.433c.07.12.21.16.33.1l1.9-.95a.938.938 0 0 1-.11-.451c0-.55.45-1.001 1-1.001s1 .45 1 1.001zm-2 6.506c0-.28-.22-.5-.5-.5h-7c-.28 0-.5.22-.5.5s.22.501.5.501h7c.28 0 .5-.22.5-.5z"
        />
    </svg>
</template>
